'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Bold = function Bold(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 30 30' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M11 15h4c.6 0 2 0 2-2 0-1.9-1.2-2-2-2h-4v4zm0 2v4h5c1.1 0 2-.5 2-2s-.9-2-2-2h-5zm0 6H9V11 9h5.9c1.5 0 2.6.6 3.4 1.8.8 1.2.9 2.8.2 4.1-.1.3-.3.5-.5.7 1.1.6 1.9 1.7 2 2.9.1 1.2-.2 2.2-1 3.1-.8.9-2 1.4-3.2 1.4H11z'
      })
    )
  );
};
/*eslint-enable */

exports.default = Bold;
//# sourceMappingURL=Bold.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Bold.js